import { useContext, useEffect, useState } from "react"
import MenuLateral from "../../../componentes/gerais/Menu"
import TopoMenu from "../../../componentes/gerais/TopoMenu"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import { indiceMenuDadosAdicionais } from "../../../componentes/gerais/menuPremiosDominio"

import { Spinner } from "../../../componentes/Spinner"

import ProfissionalAPI from "../../../servicos/ProfissionalAPI"
import { Alert, Backdrop, Button, Tab, Tabs, Zoom } from "@mui/material"
import { Campo } from "../../../componentes/form/campo"
import MensagemApp from "../../../servicos/config/MensagemApp"
import { ProtocolContainer } from "../../../componentes/gerais/CamGalleryBlock"
import { AutocompleteCidade } from "../cadastroPos/cadastroPos"

export default function DadosUsuario() {
	const [menu, setMenu] = useState(false)

	const [carregando, setCarregando] = useState(true)
	const [completo, setCompleto] = useState(false)
	const [open, setOpen] = useState(false)
	const [msg, setMsg] = useState("")

	const [dadosAdicionais, setDadosAdicionais] = useState({})
	const [codigo, setCodigo] = useState(0)
	const [ver, setVer] = useState("")
	const [identificador, setIdentificador] = useState("")

	const [tab, setTab] = useState("campos")

	const [formCampos, setFormCampos] = useState([])

	const { dados } = useContext(ContextoGeral)

	const valido = (codigo == 200 || codigo == 0) ? true : false

	const chavesCampos = dadosAdicionais?.campos ? Object.keys(dadosAdicionais.campos) : []
	const exigirEndereco = chavesCampos.includes('cidade') || chavesCampos.includes('estado') || chavesCampos.includes('cep')
	const textoPedidoEndereco = (() => {
		const partes = []
		if (chavesCampos.includes('cidade')) partes.push('a cidade')
		if (chavesCampos.includes('estado')) partes.push('o estado')
		if (chavesCampos.includes('cep')) partes.push('o CEP')
		if (partes.length === 0) return ''
		if (partes.length === 1) return `Atualize ${partes[0]} do seu endereço para continuar.`
		if (partes.length === 2) return `Atualize ${partes[0]} e ${partes[1]} do seu endereço para continuar.`
		return `Atualize ${partes[0]}, ${partes[1]} e ${partes[2]} do seu endereço para continuar.`
	})()
	const valorCampo = (nome) => {
		const item = formCampos.find(c => c.name === nome)
		return item?.value ?? ""
	}

	useEffect(() => {
		if (window.AndroidInterface)
			setVer(AndroidInterface?.recoverVersion())
	}, [])

	useEffect(() => {
		async function buscarDados() {
			let retorno = await ProfissionalAPI.buscarDadosAdicionais(dados)
			console.log(retorno)

			setCodigo(retorno?.codigo)

			if (retorno.resultado) {

				if (retorno.dados != '') {
					let arr = []
					Object.values(retorno.dados.campos || {}).forEach((item) => {
						arr.push({
							name: item.coluna || item.identificador,
							value: ""
						})
					})

					setFormCampos(arr)
					const dadosRetorno = retorno.dados
					if (dadosRetorno?.campos?.cnpj && dadosRetorno.campos.cnpj.obrigatorioOriginal === undefined) {
						dadosRetorno.campos.cnpj.obrigatorioOriginal = !!dadosRetorno.campos.cnpj.obrigatorio
					}
					if (dadosRetorno?.campos?.tipoCadastro?.valorEnviado === "PF" && dadosRetorno?.campos?.cnpj) {
						dadosRetorno.campos.cnpj.obrigatorio = false
					}
					setDadosAdicionais(dadosRetorno)
				} else {
					setCompleto(true)
					setMsg(retorno.mensagem)
					setDadosAdicionais({})
				}
			} else {
				setMsg(retorno?.mensagem)
				if (!!window.AndroidInterface) {
					window.AndroidInterface.showAndroidVersion(retorno?.mensagem)
				}

				setDadosAdicionais({})
			}
		}

		buscarDados()
	}, [carregando])

	useEffect(() => {
		if (Object.keys(dadosAdicionais).includes('docEnviadoCompleto') &&
			dadosAdicionais.docEnviadoCompleto) {
			setCompleto(true)
		}

		setCarregando(false)
	}, [dadosAdicionais])

	const handleCampos = (e) => {
		let prev = formCampos
		let arr = []
		const idCampo = e.target.id || e.target.name
		if (!idCampo || idCampo === "radio-buttons-group") return

		prev.forEach(item => {
			if (item.name == idCampo) {
				arr.push({
					name: item.name,
					value: e.target.value
				})
			} else if (idCampo === "estado" && item.name === "cidade") {
				arr.push({
					name: item.name,
					value: ""
				})
			} else {
				arr.push(item)
			}
		})

		let json = dadosAdicionais
		if (json?.campos?.[idCampo]) {
			delete json.campos[idCampo].erro
		}

		if (idCampo === "tipoCadastro" && json?.campos?.cnpj) {
			if (json.campos.cnpj.obrigatorioOriginal === undefined) {
				json.campos.cnpj.obrigatorioOriginal = !!json.campos.cnpj.obrigatorio
			}
			json.campos.cnpj.obrigatorio = e.target.value === "PF" ? false : json.campos.cnpj.obrigatorioOriginal
		}

		setDadosAdicionais({ ...json })
		setFormCampos(arr)
	}

	const enviarCampos = async () => {

		setCarregando(true)

		if (dadosAdicionais?.campos?.estado && !valorCampo("estado")?.toString().trim()) {
			setCarregando(false)
			setMsg("Selecione o estado.")
			return
		}
		if (dadosAdicionais?.campos?.cidade && !valorCampo("cidade")?.toString().trim()) {
			setCarregando(false)
			setMsg("Selecione a cidade da lista.")
			return
		}
		if (dadosAdicionais?.campos?.cep) {
			const cepDigitos = (valorCampo("cep") || "").toString().replace(/\D/g, "")
			if (cepDigitos.length < 8) {
				setCarregando(false)
				setMsg("Informe o CEP.")
				return
			}
		}

		let campos = {}
		formCampos.forEach((item => {
			campos[item.name] = item.value
		}))

		// em JavaScript filtra as propriedades de um objeto, removendo aquelas que estão “vazias” ou nulas, e retorna um novo objeto só com os campos válidos.
		// filtra chaves com valor vazio
		const camposFiltrados = Object.fromEntries(
			Object.entries(campos).filter(([_, v]) => {
				if (v == null) return false
				if (typeof v === "string") return v.trim() !== ""
				if (Array.isArray(v)) return v.length > 0
				if (typeof v === "object") return Object.keys(v).length > 0
				return true // números/booleans etc.
			})
		)

		// evita chamada se tudo estiver vazio
		if (Object.keys(camposFiltrados).length === 0) {
			setCarregando(false)
			setMsg("Preencha ao menos um campo antes de enviar.")
			return
		}

		// fim do filtro

		let retorno = await ProfissionalAPI.enviarDadosUsuario(dados, camposFiltrados)
		if (retorno?.resultado) {
			if (!!window.AndroidInterface) {
				console.log("passou")
				window.AndroidInterface?.showAndroidVersion(retorno?.mensagem)
			}

			setCarregando(false)
		} else {
			if (!!window.AndroidInterface) {
				window.AndroidInterface.showAndroidVersion(retorno?.mensagem)
			}

			if (retorno.aux != '') {
				if (retorno.aux in campos) {
					let json = dadosAdicionais

					formCampos.forEach((item, i) => {
						if (item.name == retorno.aux) {
							json.campos[retorno.aux] = { ...json.campos[retorno.aux], erro: retorno.mensagem }
						}
					})

					setDadosAdicionais(prev => {
						return { ...prev, ...json }
					})
				}
			}

			setCarregando(false)
		}
	}

	const handleArquivo = (e) => {
		e.preventDefault()

		if (!!window.AndroidInterface) {
			window.finalizouEnvio = (res) => {
				let retorno = JSON.parse(res)
				alert(JSON.stringify(retorno, null, 3))
				e.target.blur()
				setCarregando(true)

				if (retorno?.resultado) {
					if (!!window.AndroidInterface) {
						window.AndroidInterface.showAndroidVersion(retorno?.mensagem)
					}

				} else {
					if (!!window.AndroidInterface) {
						window.AndroidInterface.showAndroidVersion(retorno?.mensagem ?? MensagemApp.timeout)
					}
				}
			}

			window.AndroidInterface.ativaCamera('DC', parseInt(dados.idProf), 0, 0, 'FP', e.target.id, 'uploadImg', dados.token)
		}
	}

	return <>
		<div className="h-screen">
			<TopoMenu
				voltar={exigirEndereco ? () => {} : "/app/home"}
				titulo="DADOS ADICIONAIS"
				setShow={exigirEndereco ? undefined : setMenu}
			/>
			<div className="mx-2" style={{ height: 'calc(100% - 3rem)' }}>
				{carregando && dadosAdicionais.length > 0
					? <Spinner />
					: valido
						? completo
							? <div className="flex flex-col justify-between" style={{ height: '100%' }}>
								<Alert security="success" className="mt-3">
									Seus dados já foram enviados com sucesso!
								</Alert>
							</div>
							: <div className="flex flex-col justify-between" style={{ height: '100%' }}>
								<div>
									<Tabs value={tab} className="my-3" onChange={(e, v) => setTab(v)} centered TabIndicatorProps={{ style: { display: 'none' } }}>
										{Array.isArray(formCampos) &&
											<Tab value="campos"
												sx={{
													backgroundColor: tab === 'campos' ? "var(--primaria-pura)" : "#cdcbc9",
													color: tab === 'campos' ? "white !important" : "black !important",
													width: "50%",
													borderRadius: "10px",
													marginRight: "2px",
													// Remove efeitos visuais indesejados
													"&.Mui-selected": {
														backgroundColor: "var(--primaria-pura)",
														color: "white",
													}
												}}
												label={dadosAdicionais.labelBtnTexto ?? "Dados"}
											/>}
										{dadosAdicionais.arquivos && Object.keys(dadosAdicionais.arquivos).length > 0
											&&
											<Tab value="arquivos"
												sx={{
													backgroundColor: tab === 'arquivos' ? "var(--primaria-pura)" : "#cdcbc9",
													color: tab === 'arquivos' ? "white !important" : "black !important",
													width: "50%",
													borderRadius: "10px",
													// Remove efeitos visuais indesejados
													"&.Mui-selected": {
														backgroundColor: "var(--primaria-pura)",
														color: "white",
													}
												}}
												label={dadosAdicionais.labelBtnArquivo ?? "Arquivos"}
											/>}
									</Tabs>

									{tab == "campos" && <>
										{exigirEndereco && (
											<Alert severity="info" className="mt-3">
												{textoPedidoEndereco}
											</Alert>
										)}
										{msg && (
											<Alert severity="warning" className="mt-3">{msg}</Alert>
										)}
										{dadosAdicionais.campos && Object.values(dadosAdicionais.campos).map((e, i) => {
											if (e.enviado) return
											const idCampo = e.coluna || e.identificador || e.label
											const isCidade = idCampo === "cidade"

											return <div key={idCampo}>
												<Zoom
													className="mt-3"
													in={true}
													style={{ transitionDelay: i * (1000 / (Object.keys(dadosAdicionais.campos).length) ?? 10) }}
												>
													<div className="mt-3">
														{isCidade
															? <AutocompleteCidade
																id={idCampo}
																value={valorCampo("cidade")}
																uf={valorCampo("estado")}
																onChange={(novaCidade) => handleCampos({ target: { id: idCampo, value: novaCidade } })}
																placeholder={e.label}
																obrigatorio={!!e.obrigatorio}
															/>
															: <Campo
																id={idCampo}
																label={e.label}
																tipo={e.tipoCampo}
																options={e?.opcoes ?? null}
																danger={!!e.erro ? 1 : 0}
																value={valorCampo(idCampo)}
																onChange={handleCampos}
																obrigatorio={!!e.obrigatorio}
																mask={idCampo === "cep" ? "99999-999" : (idCampo === "cnpj" ? "**.***.***/****-99" : undefined)}
																estado={valorCampo("estado")}
																dominio={dados.dominio}
																token={dados.token}
																idProf={dados.idProf}
															/>}
														<div className="text-danger">
															{e?.erro}
														</div>
													</div>
												</Zoom>
											</div>
										})}
										<Button className="p-2" sx={{ marginTop: "1rem", marginBottom: "1rem" }} onClick={enviarCampos} variant="contained" fullWidth>
											Enviar
										</Button>
									</>}

									{tab == "arquivos" && <>
										{Object.values(dadosAdicionais.arquivos).map((e, i) => {

											return <div key={e?.coluna ?? e.identificador}>
												<Zoom
													className="mt-3"
													in={true}
													style={{
														transitionDelay: Object.keys(dadosAdicionais.campos).length > 0
															? i * (1000 / (Object.keys(dadosAdicionais.campos).length ?? 10))
															: 0
													}}
												>
													<div className="mt-3">
														{ver >= 102.26
															? <button onClick={() => {
																setIdentificador(e.coluna ?? e.identificador)
																setOpen(true)
															}} className="w-full">
																{e.label}
															</button>
															: <Campo
																id={e.coluna ?? e.identificador}
																label={e.label}
																tipo={e.tipoCampo}
																tabindex="-1"
																onChange={handleArquivo}
															/>}
													</div>
												</Zoom>
											</div>
										})}
									</>}

								</div>
							</div>
						: <div>
							<Alert severity="error" className="mt-3">
								{msg}
							</Alert>
						</div>}
			</div>
		</div>

		<Backdrop open={open}>
			<ProtocolContainer
				handleClose={() => setOpen(false)}
				handleDB={async URL => ProfissionalAPI.salvarDadosAdicionais(dados, {
					identificador: identificador,
					idProf: dados.idProf,
					link: URL
				}).then(res => {
					if (res.sucesso) {
						try {
							AndroidInterface.showAndroidVersion(res.mensagem)
						} catch {
							alert(res.mensagem)
						}
						setOpen(false)
						setCarregando(true)
					}
				}).catch(rej => alert(JSON.stringify(rej, null, 3)))}
				onObsolete={() => {
					//
				}}
				opcao=""
				reload={() => {
					setCarregando(true)
					setOpen(false)
				}}
			/>
		</Backdrop>
		<MenuLateral show={exigirEndereco ? false : menu} setShow={setMenu} ativo={indiceMenuDadosAdicionais(dados.dominio)} />
	</>
}